"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeTypoUnnecessary = exports.normalizeFontNames = exports.normalizeLetterSpace = exports.normalizeFontWeight = exports.normalizeFontStyle = exports.matchFontToWeight = void 0;
var FontType;
(function (FontType) {
    FontType["Regular"] = "Regular";
    FontType["Medium"] = "Medium";
    FontType["Semibold"] = "Semibold";
    FontType["Bold"] = "Bold";
    FontType["Unknown"] = "Unknown";
})(FontType || (FontType = {}));
var FontTypeWeight;
(function (FontTypeWeight) {
    FontTypeWeight["Regular"] = "400";
    FontTypeWeight["Medium"] = "500";
    FontTypeWeight["Semibold"] = "600";
    FontTypeWeight["Bold"] = "700";
})(FontTypeWeight || (FontTypeWeight = {}));
var matchFontToWeight = function (style) {
    var fontFamily = style.fontFamily, fontWeight = style.fontWeight;
    if (fontFamily.includes('Regular') || fontWeight === FontTypeWeight.Regular) {
        return FontType.Regular;
    }
    if (fontFamily.includes('Medium') || fontWeight === FontTypeWeight.Medium) {
        return FontType.Medium;
    }
    if (fontFamily.includes('Semibold') || fontWeight === FontTypeWeight.Semibold) {
        return FontType.Semibold;
    }
    if (fontFamily.includes('Bold') || fontWeight === FontTypeWeight.Bold) {
        return FontType.Bold;
    }
    return FontType.Unknown;
};
exports.matchFontToWeight = matchFontToWeight;
/**
 * Нормализаторы для работы с типографикой
 */
var normalizeFontStyle = function (style) {
    if (!style.fontStyle) {
        style.fontStyle = 'normal';
    }
    return style;
};
exports.normalizeFontStyle = normalizeFontStyle;
var normalizeFontWeight = function (style) {
    var type = (0, exports.matchFontToWeight)(style);
    switch (type) {
        case FontType.Regular:
            style.fontWeight = FontTypeWeight.Regular.toString();
            return style;
        case FontType.Medium:
            style.fontWeight = FontTypeWeight.Medium.toString();
            return style;
        case FontType.Semibold:
            style.fontWeight = FontTypeWeight.Semibold.toString();
            return style;
        case FontType.Bold:
            style.fontWeight = FontTypeWeight.Bold.toString();
            return style;
        default:
            return style;
    }
};
exports.normalizeFontWeight = normalizeFontWeight;
var normalizeLetterSpace = function (style) {
    var fontSize = parseInt(String(style.fontSize), 10);
    var letterSpacing = parseFloat(String(style.letterSpacing));
    if (letterSpacing === 0) {
        style.letterSpacing = 'normal';
    }
    else {
        var letterSpacingInEm = (letterSpacing / fontSize).toPrecision(3);
        style.letterSpacing = "".concat(letterSpacingInEm, "em");
    }
    return style;
};
exports.normalizeLetterSpace = normalizeLetterSpace;
var normalizeFontNames = function (style) {
    var type = (0, exports.matchFontToWeight)(style);
    if (type === FontType.Unknown) {
        return style;
    }
    // TODO: sync this with "services/shared-static"
    style.fontFamily = style.fontFamily.replace("SBSansText-".concat(type), 'SB Sans Text');
    return style;
};
exports.normalizeFontNames = normalizeFontNames;
var removeTypoUnnecessary = function (style) {
    delete style.color;
    delete style.textAlign;
    delete style.textDecoration;
    return style;
};
exports.removeTypoUnnecessary = removeTypoUnnecessary;
//# sourceMappingURL=normalizers.js.map